"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStreamAptosOperation = void 0;
var dataTypes_1 = require("../../dataTypes");
exports.getStreamAptosOperation = {
    method: 'GET',
    name: 'getStreamAptos',
    id: 'aptosStreamsGet',
    groupName: 'aptosStreams',
    urlPathPattern: '/streams/aptos/{id}',
    urlPathParamNames: ['id'],
    getRequestUrlParams: getRequestUrlParams,
    deserializeResponse: deserializeResponse,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
};
// Methods
function getRequestUrlParams(request) {
    return {
        id: request.id,
    };
}
function deserializeResponse(jsonResponse) {
    return dataTypes_1.AptosStream.create(jsonResponse);
}
function serializeRequest(request) {
    return {
        id: request.id,
    };
}
function deserializeRequest(jsonRequest) {
    return {
        id: jsonRequest.id,
    };
}
//# sourceMappingURL=getStreamAptosOperation.js.map